<script setup lang="ts">
    import type { SurgicalApproachOption } from '@/domain/case/surgery';

    defineProps<{
        surgicalApproachId: string;
        surgicalApproachOptions: SurgicalApproachOption[];
        hasUnsavedChanges: boolean;
    }>();

    defineEmits<{
        save: [];
        'update:surgical-approach': [value: string];
    }>();
</script>

<template>
    <app-form-section-title>Surgical Guide Preferences</app-form-section-title>
    <app-form-subtitle>Select your preferred surgical approach</app-form-subtitle>

    <app-form-group label="Surgical Approach" optional data-testid="surgical-approach">
        <app-toggle
            :model-value="surgicalApproachId"
            :options="surgicalApproachOptions"
            @update:model-value="$emit('update:surgical-approach', $event)"
        />
    </app-form-group>

    <app-form-actions>
        <app-form-action-notification
            v-if="hasUnsavedChanges"
            data-testid="surgical-guide-has-changes-warning"
            message="You have unsaved surgical guide changes"
        />
        <app-button-primary
            height="55"
            class="px-8"
            width="350"
            data-testid="surgical-guide-submit-button"
            :disabled="!hasUnsavedChanges"
            @click="$emit('save')"
        >Save Surgical Guide Preferences
        </app-button-primary>
    </app-form-actions>
</template>
